export default __webpack_public_path__ + "assets/front/scss/affichage-mosaic.1654a53a6fa2265512d450900c070114.css";